import Navbar from './navbar';

const Layout = ({ children }) => {
    return (
        <div>
            <Navbar />
            <main className='mb-5'>{children}</main>
        </div>
    );
};

export default Layout;
